export const API_BASE: string = import.meta.env.VITE_API_BASE || '';

// True only in the local Vite dev server. Centralised here so components can
// gate dev-only affordances without referencing `import.meta` directly (which
// cannot be parsed by the Jest/ts-jest test runner).
export const IS_DEV: boolean = import.meta.env.DEV === true;

export function apiUrl(path: string): string {
  if (API_BASE && path.startsWith('/')) {
    return `${API_BASE}${path}`;
  }
  return `${API_BASE}${path}`;
}

interface ApiConfig {
  API_BASE: string;
  apiUrl: (_path: string) => string;
}

const config: ApiConfig = { API_BASE, apiUrl };

export default config;
